export default __webpack_public_path__ + "static/media/support4.4483294b.jpeg";